import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'white';
    size?: 'sm' | 'md' | 'lg';
    children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
    variant = 'primary',
    size = 'md',
    className = '',
    children,
    ...props
}) => {
    const baseStyles = "inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none rounded-lg";

    const variants = {
        // Primary: Royal Violet (Smart, Tech, Premium)
        primary: "bg-violet-600 text-white hover:bg-violet-700 focus:ring-violet-500 shadow-md hover:shadow-lg",
        // Secondary: Slate (Professional)
        secondary: "bg-slate-800 text-white hover:bg-slate-900 focus:ring-slate-600 shadow-sm",
        outline: "border border-slate-300 bg-transparent hover:bg-slate-100 text-slate-700",
        ghost: "bg-transparent hover:bg-slate-100 text-slate-700",
        white: "bg-white text-violet-600 hover:bg-violet-50 focus:ring-white/50 shadow-sm",
    };

    const sizes = {
        sm: "h-9 px-3 text-sm",
        md: "h-11 px-6 text-base",
        lg: "h-14 px-8 text-lg",
    };

    return (
        <button
            className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};
